import React from "react";
import { BrandsIUse } from "./BrandsIUse";
import { ExperienceSection } from "./ExperienceSection";
import { Footer } from "./Footer";
import { Hero } from "./Hero";
import Navigation from "./Navigation";
import { PortfolioSection } from "./PortfolioSection";
import { WhatCanIOfferSection } from "./WhatCanIOfferSection";
import { WhyChooseMeSection } from "./WhyChooseMeSection";

export const Home = () => {
  return (
    <div data-aos="fade-in">
      <header>
        <Navigation />
        <Hero />
      </header>
      <main>
        <ExperienceSection />
        <WhatCanIOfferSection />
        <WhyChooseMeSection />
        <PortfolioSection />
        <BrandsIUse />
      </main>
      <Footer />
    </div>
  );
};
